module.exports = __webpack_public_path__ + "static/media/ChronicDisease.937e55b8.svg";